import React from 'react';
import * as S from './style';
import { useStore } from '../../contexts/MapContext';

const TopInfo = () => {
  const { address, setOpenModal, setLocation, setAddress } = useStore();

  const handleCotainerClick = () => {
    setAddress('');
    setLocation([37.3595704, 127.105399]);
    setOpenModal(true);
  };
  return (
    <S.ContainerWrapper>
      <S.Container onClick={handleCotainerClick}>
        <S.Label>현재 위치</S.Label>
        <S.Address>
          {address !== '' ? address : '기기의 GPS 정보를 수신했습니다.'}
        </S.Address>
        <S.Hint>다른 위치에서 찾고 싶으신가요? 이곳을 눌러주세요.</S.Hint>
      </S.Container>
    </S.ContainerWrapper>
  );
};

export default TopInfo;
